// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.typeahead-container {
  background-color: white;
}
.select-body-container .options-container .option-container .text {
  margin-left: 0;
}
.select-body-container .options-container .option-container.selected {
  color: #ffffff;
  background-color: #7F6C2E;
}
.select-body-container .options-container .heading.selectable:hover {
  background-color: #7F6C2E !important;
}
.select-body-container .options-container .heading.selectable:hover span {
  color: #ffffff;
}
.dropdown-menu button {
  min-height: 42px;
}
button:focus,
button:active,
ngbdropdown {
  border: 1px solid #d4cfbe;
  outline: none !important;
  scrollbar-shadow-color: transparent !important;
  color: #333333;
}
button {
  min-width: 40px;
  width: auto;
  background-color: #ffffff;
  border: 1px solid #d4cfbe;
  padding: 8px 11px 8px 11px;
  font-family: Montserrat-Light, sans-serif;
  font-size: 15px;
  position: relative;
  text-align: left;
  border-radius: 0;
  margin-top: 0;
  margin-bottom: 0;
}
.dropdown-menu button {
  border: none;
}
.dropdown-menu .dropdown-item-search:focus,
.dropdown-menu .dropdown-item-search:active {
  border: 1px solid #7F6C2E !important;
  outline: none !important;
  scrollbar-shadow-color: transparent !important;
}
.dropdown-menu .select-all:focus,
.dropdown-menu .select-all:active {
  border: none !important;
  outline: none !important;
  scrollbar-shadow-color: transparent !important;
}
.dropdown-menu .select-all button:focus,
.dropdown-menu .select-all button:active {
  border: none !important;
  outline: none !important;
  scrollbar-shadow-color: transparent !important;
}
.dropdown-item:hover:not(.disabled):not(.select-all),
.dropdown-item:active:not(.disabled):not(.select-all),
.dropdown-item:focus:not(.disabled):not(.select-all) {
  color: #ffffff;
  background-color: #7F6C2E !important;
  width: 100%;
}
.dropdown-item:hover:not(.disabled):not(.select-all) .select-all-btn,
.dropdown-item:active:not(.disabled):not(.select-all) .select-all-btn,
.dropdown-item:focus:not(.disabled):not(.select-all) .select-all-btn {
  color: #ffffff;
}
.dropdown-menu {
  padding: 0;
  width: 100%;
  margin: 0 0 85px;
  border-radius: 0;
  max-height: 508px;
  border-top: 0;
  overflow-y: scroll;
  overscroll-behavior: contain;
}
.dropdown-toggle-placeholder {
  color: #999999;
}
.dropdown-toggle {
  text-align: left;
  border: 1px solid #d4cfbe;
  outline: none;
  box-shadow: none;
  border-radius: 0 !important;
  min-height: 40px;
  width: 100%;
}
.collapse {
  display: block;
  width: 23px;
  height: 23px;
  float: right;
  background-image: url('open-chev-big.f05d398ec6e57c90.svg');
}
.collapse.active {
  background-image: url('closed-chev-big.847c1b52d4b4a306.svg');
}
.collapse:hover {
  cursor: pointer;
}
.clear-input {
  position: absolute;
  z-index: 5;
  bottom: 5px;
  right: 40px;
  height: 24px;
  width: 24px;
  background-image: url('cross.94f7db39b7176d24.svg');
  background-repeat: no-repeat;
  background-position: center;
  visibility: hidden;
}
.clear-input:hover {
  background-image: url('cross-hover.51d99dd21ec0e20c.svg');
  cursor: pointer;
}
button:hover:not(.disabled) {
  cursor: pointer;
}
button:hover:not(.disabled) .clear-input {
  visibility: visible;
}
.dropdown-item-search-container .dropdown-item-search {
  width: 100%;
}
.dropdown-item-search-container {
  width: 100%;
  height: 65px;
  padding: 15px 10px 10px;
}
.dropdown-menu .heading {
  color: #b39841;
}
.dropdown-menu .selectable:focus,
.dropdown-menu .selectable:active,
.dropdown-menu .selectable:hover {
  color: white;
}
.checkbox .check {
  width: 16px;
  height: 16px;
  background-image: url('off-check.b27a559404abf43a.svg');
  background-position: left;
  background-size: cover;
  position: absolute;
}
.checkbox .check.checked {
  background-image: url('on-check.dcb1a0af428956b0.svg');
}
.checkbox .text {
  margin-left: 8px;
}
.pills-container {
  display: block;
  width: 100%;
}
.pills-container .pill {
  margin-top: 4px;
  width: auto;
  float: left;
  background-color: #7F6C2E;
  padding: 4px 8px 4px 8px;
  opacity: 1;
  min-height: 30px;
  margin-right: 5px;
  transition: opacity 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);
  white-space: normal;
  word-break: break-word;
}
.pills-container .pill span {
  color: #ffffff;
}
.pills-container .pill .remove {
  display: inline-block;
  background-image: url('dropdown-x.d3c3408902547efd.svg');
  background-size: cover;
  width: 15px;
  height: 15px;
  vertical-align: middle;
  margin-bottom: 3px;
  margin-left: 8px;
}
.pills-container .pill.animate {
  opacity: 0;
}
.pills-container .pill:focus,
.pills-container .pill:active,
.pills-container .pill:hover {
  background-color: #f4f2ea;
}
.pills-container .pill:focus span,
.pills-container .pill:active span,
.pills-container .pill:hover span {
  color: #7F6C2E !important;
}
.pills-container .pill:focus .remove,
.pills-container .pill:active .remove,
.pills-container .pill:hover .remove {
  background-image: url('hover-x.51d99dd21ec0e20c.svg');
}
.pillsInput {
  float: left;
  height: 37px;
}
#dropdownMultiSelect {
  padding: 0 8px;
}
.select-all-btn,
.clear-selected {
  color: #b39841;
}
.checkbox button {
  width: unset;
  padding: 0;
  border: none;
  height: 18px;
}
.clear-selected {
  margin-right: 10px;
  float: right;
}
.clear-selected:hover,
.clear-selected:active,
.clear-selected:focus {
  color: #000000;
  border: none;
  outline: none;
  box-shadow: 0 0;
}
.select-all .select-all-btn:hover,
.select-all .select-all-btn:active,
.select-all .select-all-btn:focus {
  color: #d4cfbe;
  border: none;
  outline: none;
  box-shadow: 0 0;
}
input[type="text"] {
  min-width: 250px;
  width: 100%;
  font-size: 15px;
  font-family: Montserrat-Light, sans-serif;
  padding-left: 8px;
  outline: none;
  border: none;
  padding-top: 8px;
  background-color: transparent;
  display: inline-block;
  vertical-align: top;
  padding-bottom: 8px;
}
input[type="text"].full-width {
  width: 100%;
}
input[type="text"]::-ms-clear {
  display: none;
}
.dropdown .btn[disabled] {
  opacity: 1;
}
.spinner {
  position: absolute;
  height: 24px;
  width: 24px;
  top: 6px;
  right: 8px;
  animation: rotating 2s linear infinite;
  background-image: url('oir-spinner-small.38258953cb4050d3.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 0;
  margin-top: 5px;
}
.spinner.active {
  -webkit-animation: rotation 0.7s infinite linear;
  opacity: 1;
}
::ng-deep oir-typeahead.invalid .dropdown-toggle {
  background-color: #ffe5e9 !important;
  border: 1px solid #c30e2e !important;
}
::ng-deep oir-typeahead.invalid .dropdown-toggle .pills-container {
  background-color: #ffe5e9 !important;
  font-family: Montserrat-Light, sans-serif !important;
}
::ng-deep oir-typeahead.invalid .dropdown-toggle .collapse {
  background-color: #ffe5e9 !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/typeahead/typeahead.component.less"],"names":[],"mappings":"AAEA;EACI,uBAAA;AADJ;AAIA;EAIgB,cAAA;AALhB;AAQY;EACI,cAAA;EACA,yBAAA;AANhB;AAHA;EAcY,oCAAA;AARZ;AANA;EAiBgB,cAAA;AARhB;AAcA;EACI,gBAAA;AAZJ;AAeA;;;EAGI,yBAAA;EACA,wBAAA;EACA,8CAAA;EACA,cAAA;AAbJ;AAgBA;EACI,eAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;AAdJ;AAiBA;EACI,YAAA;AAfJ;AAkBA;;EAEI,oCAAA;EACA,wBAAA;EACA,8CAAA;AAhBJ;AAmBA;;EAEI,uBAAA;EACA,wBAAA;EACA,8CAAA;AAjBJ;AAoBA;;EAEI,uBAAA;EACA,wBAAA;EACA,8CAAA;AAlBJ;AAqBA;;;EAGI,cAAA;EACA,oCAAA;EACA,WAAA;AAnBJ;AAcA;;;EAQQ,cAAA;AAjBR;AAqBA;EACI,UAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,4BAAA;AAnBJ;AAsBA;EACI,cAAA;AApBJ;AAuBA;EACI,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;AArBJ;AAwBA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,2DAAA;AAtBJ;AAwBI;EACI,6DAAA;AAtBR;AAyBI;EACI,eAAA;AAvBR;AA2BA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;AAzBJ;AA2BI;EACI,yDAAA;EACA,eAAA;AAzBR;AA8BI;EACI,eAAA;AA5BR;AA2BI;EAIQ,mBAAA;AA5BZ;AAiCA;EACI,WAAA;AA/BJ;AAkCA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;AAhCJ;AAmCA;EACI,cAAA;AAjCJ;AAoCA;;;EAGI,YAAA;AAlCJ;AAqCA;EAEQ,WAAA;EACA,YAAA;EACA,uDAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AApCR;AA6BA;EAWQ,sDAAA;AArCR;AA0BA;EAeQ,gBAAA;AAtCR;AA0CA;EACI,cAAA;EACA,WAAA;AAxCJ;AAsCA;EAKQ,eAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;EACA,wBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,4DAAA;EACA,mBAAA;EACA,sBAAA;AAxCR;AAyBA;EAkBY,cAAA;AAxCZ;AAsBA;EAsBY,qBAAA;EACA,wDAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;AAzCZ;AA4CQ;EACI,UAAA;AA1CZ;AASA;;;EA0CQ,yBAAA;AA9CR;AAIA;;;EAuCY,yBAAA;AAtCZ;AADA;;;EA6CY,qDAAA;AAvCZ;AA4CA;EACI,WAAA;EACA,YAAA;AA1CJ;AA6CA;EACI,cAAA;AA3CJ;AA8CA;;EACI,cAAA;AA3CJ;AA8CA;EACI,YAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AA5CJ;AA+CA;EACI,kBAAA;EACA,YAAA;AA7CJ;AAgDA;;;EAGI,cAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AA9CJ;AAiDA;;;EAGI,cAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AA/CJ;AAkDA;EACI,gBAAA;EACA,WAAA;EACA,eAAA;EACA,yCAAA;EACA,iBAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;AAhDJ;AAkDI;EACI,WAAA;AAhDR;AAmDI;EACI,aAAA;AAjDR;AAqDA;EACI,UAAA;AAnDJ;AAsDA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;EACA,sCAAA;EACA,+DAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;AApDJ;AAsDI;EACI,gDAAA;EACA,UAAA;AApDR;AAyDI;EAEQ,oCAAA;EACA,oCAAA;AAxDZ;AAqDI;EAMY,oCAAA;EACA,oDAAA;AAxDhB;AAiDI;EAWY,oCAAA;AAzDhB","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.typeahead-container {\n    background-color: white\n}\n\n.select-body-container {\n    .options-container {\n        .option-container {\n            .text {\n                margin-left: 0;\n            }\n\n            &.selected {\n                color: @white;\n                background-color: @primary-base;\n            }\n        }\n\n        .heading.selectable:hover {\n            background-color: @primary-base !important;\n\n            span {\n                color: @white;\n            }\n        }\n    }\n}\n\n.dropdown-menu button {\n    min-height: 42px;\n}\n\nbutton:focus,\nbutton:active,\nngbdropdown {\n    border: 1px solid @primary-50;\n    outline: none !important;\n    scrollbar-shadow-color: transparent !important;\n    color: @secondary-base\n}\n\nbutton {\n    min-width: 40px;\n    width: auto;\n    background-color: @white;\n    border: 1px solid @primary-50;\n    padding: 8px 11px 8px 11px;\n    font-family: Montserrat-Light, sans-serif;\n    font-size: 15px;\n    position: relative;\n    text-align: left;\n    border-radius: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.dropdown-menu button {\n    border: none;\n}\n\n.dropdown-menu .dropdown-item-search:focus,\n.dropdown-menu .dropdown-item-search:active {\n    border: 1px solid @primary-base !important;\n    outline: none !important;\n    scrollbar-shadow-color: transparent !important;\n}\n\n.dropdown-menu .select-all:focus,\n.dropdown-menu .select-all:active {\n    border: none !important;\n    outline: none !important;\n    scrollbar-shadow-color: transparent !important;\n}\n\n.dropdown-menu .select-all button:focus,\n.dropdown-menu .select-all button:active {\n    border: none !important;\n    outline: none !important;\n    scrollbar-shadow-color: transparent !important;\n}\n\n.dropdown-item:hover:not(.disabled):not(.select-all),\n.dropdown-item:active:not(.disabled):not(.select-all),\n.dropdown-item:focus:not(.disabled):not(.select-all) {\n    color: @white;\n    background-color: @primary-base !important;\n    width: 100%;\n\n    .select-all-btn {\n        color: @white;\n    }\n}\n\n.dropdown-menu {\n    padding: 0;\n    width: 100%;\n    margin: 0 0 85px;\n    border-radius: 0;\n    max-height: 508px;\n    border-top: 0;\n    overflow-y: scroll;\n    overscroll-behavior: contain;\n}\n\n.dropdown-toggle-placeholder {\n    color: @secondary-60;\n}\n\n.dropdown-toggle {\n    text-align: left;\n    border: 1px solid @primary-50;\n    outline: none;\n    box-shadow: none;\n    border-radius: 0 !important;\n    min-height: 40px;\n    width: 100%;\n}\n\n.collapse {\n    display: block;\n    width: 23px;\n    height: 23px;\n    float: right;\n    background-image: url(\"../../styles/img/open-chev-big.svg\");\n\n    &.active {\n        background-image: url(\"../../styles/img/closed-chev-big.svg\");\n    }\n\n    &:hover {\n        cursor: pointer;\n    }\n}\n\n.clear-input {\n    position: absolute;\n    z-index: 5;\n    bottom: 5px;\n    right: 40px;\n    height: 24px;\n    width: 24px;\n    background-image: url(\"../../styles/img/cross.svg\");\n    background-repeat: no-repeat;\n    background-position: center;\n    visibility: hidden;\n\n    &:hover {\n        background-image: url(\"../../styles/img/cross-hover.svg\");\n        cursor: pointer;\n    }\n}\n\nbutton {\n    &:hover:not(.disabled) {\n        cursor: pointer;\n\n        .clear-input {\n            visibility: visible;\n        }\n    }\n}\n\n.dropdown-item-search-container .dropdown-item-search {\n    width: 100%;\n}\n\n.dropdown-item-search-container {\n    width: 100%;\n    height: 65px;\n    padding: 15px 10px 10px;\n}\n\n.dropdown-menu .heading {\n    color: @primary-90;\n}\n\n.dropdown-menu .selectable:focus,\n.dropdown-menu .selectable:active,\n.dropdown-menu .selectable:hover {\n    color: white;\n}\n\n.checkbox {\n    .check {\n        width: 16px;\n        height: 16px;\n        background-image: url(../../styles/img/off-check.svg);\n        background-position: left;\n        background-size: cover;\n        position: absolute;\n    }\n\n    .check.checked {\n        background-image: url(../../styles/img/on-check.svg);\n    }\n\n    .text {\n        margin-left: 8px;\n    }\n}\n\n.pills-container {\n    display: block;\n    width: 100%;\n\n    .pill {\n        margin-top: 4px;\n        width: auto;\n        float: left;\n        background-color: @primary-base;\n        padding: 4px 8px 4px 8px;\n        opacity: 1;\n        min-height: 30px;\n        margin-right: 5px;\n        transition: opacity 0.2s cubic-bezier(0.215, 0.61, 0.355, 1);\n        white-space: normal;\n        word-break: break-word;\n\n        span {\n            color: @white;\n        }\n\n        .remove {\n            display: inline-block;\n            background-image: url(../../styles/img/dropdown-x.svg);\n            background-size: cover;\n            width: 15px;\n            height: 15px;\n            vertical-align: middle;\n            margin-bottom: 3px;\n            margin-left: 8px;\n        }\n\n        &.animate {\n            opacity: 0;\n        }\n    }\n\n    .pill:focus, .pill:active, .pill:hover {\n        span {\n            color: @primary-base !important;\n        }\n\n        background-color: @primary-40;\n\n        .remove {\n            background-image: url(../../styles/img/hover-x.svg);\n        }\n    }\n}\n\n.pillsInput {\n    float: left;\n    height: 37px;\n}\n\n#dropdownMultiSelect {\n    padding: 0 8px;\n}\n\n.select-all-btn, .clear-selected {\n    color: @primary-90;\n}\n\n.checkbox button {\n    width: unset;\n    padding: 0;\n    border: none;\n    height: 18px;\n}\n\n.clear-selected {\n    margin-right: 10px;\n    float: right;\n}\n\n.clear-selected:hover,\n.clear-selected:active,\n.clear-selected:focus {\n    color: @black;\n    border: none;\n    outline: none;\n    box-shadow: 0 0;\n}\n\n.select-all .select-all-btn:hover,\n.select-all .select-all-btn:active,\n.select-all .select-all-btn:focus {\n    color: @primary-50;\n    border: none;\n    outline: none;\n    box-shadow: 0 0;\n}\n\ninput[type=\"text\"] {\n    min-width: 250px;\n    width: 100%;\n    font-size: 15px;\n    font-family: Montserrat-Light, sans-serif;\n    padding-left: 8px;\n    outline: none;\n    border: none;\n    padding-top: 8px;\n    background-color: transparent;\n    display: inline-block;\n    vertical-align: top;\n    padding-bottom: 8px;\n\n    &.full-width {\n        width: 100%;\n    }\n\n    &::-ms-clear {\n        display: none;\n    }\n}\n\n.dropdown .btn[disabled] {\n    opacity: 1;\n}\n\n.spinner {\n    position: absolute;\n    height: 24px;\n    width: 24px;\n    top: 6px;\n    right: 8px;\n    animation: rotating 2s linear infinite;\n    background-image: url(../../styles/img/oir-spinner-small.svg);\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    opacity: 0;\n    margin-top: 5px;\n\n    &.active {\n        -webkit-animation: rotation .7s infinite linear;\n        opacity: 1;\n    }\n}\n\n::ng-deep oir-typeahead {\n    &.invalid {\n        .dropdown-toggle {\n            background-color: @invalid-fill !important;\n            border: 1px solid @invalid-outline !important;\n\n            .pills-container {\n                background-color: @invalid-fill !important;\n                font-family: Montserrat-Light, sans-serif !important;\n            }\n\n            .collapse {\n                background-color: @invalid-fill !important;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
